import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SolutionSection = () => {
  const [activeView, setActiveView] = useState<'traditional' | 'ai'>('traditional');

  const handleTestClick = () => {
    window.open('https://t.me/Aidating_love7_bot?start=003_res', '_blank');
  };

  return (
    <section id="how-it-works" className="py-20 sm:py-32 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full text-primary text-sm font-medium mb-4">
            <Icon name="Sparkles" size={16} />
            <span>Цифровой двойник работает за вас</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Не анкеты — готовые результаты
          </h2>
          <p className="text-lg text-secondary max-w-2xl mx-auto">
            Вы не выбираете анкеты, не переписываетесь, не проверяете на мошенников. Ваш цифровой двойник проводит тысячи свиданий и доставляет вам лучшие совпадения.
          </p>
        </div>

        <div className="flex justify-center gap-4 mb-12">
          <button
            onClick={() => setActiveView('traditional')}
            className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
              activeView === 'traditional' ?'bg-destructive text-destructive-foreground shadow-lg' :'bg-card text-secondary hover:bg-muted'
            }`}
          >
            Традиционный способ
          </button>
          <button
            onClick={() => setActiveView('ai')}
            className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
              activeView === 'ai' ?'bg-primary text-primary-foreground shadow-lg' :'bg-card text-secondary hover:bg-muted'
            }`}
          >
            С AI Dating
          </button>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className={`transition-all duration-500 ${activeView === 'traditional' ? 'opacity-100 scale-100' : 'opacity-50 scale-95'}`}>
            <div className="bg-card rounded-2xl p-8 border-2 border-destructive/20 h-full">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
                  <Icon name="Frown" size={24} color="var(--color-destructive)" />
                </div>
                <h3 className="text-2xl font-bold text-foreground">Традиционные приложения</h3>
              </div>

              <div className="space-y-6">
                {[
                  { icon: 'Clock', text: 'Вы сами свайпите анкеты часами', progress: 85 },
                  { icon: 'MessageSquare', text: 'Вы сами переписываетесь с десятками людей', progress: 70 },
                  { icon: 'AlertCircle', text: 'Вы сами проверяете на мошенников', progress: 60 },
                  { icon: 'TrendingDown', text: 'Эмоциональное выгорание от процесса', progress: 90 }
                ].map((item, index) => (
                  <div key={index} className="space-y-2">
                    <div className="flex items-center gap-3">
                      <Icon name={item.icon as any} size={20} color="var(--color-destructive)" />
                      <span className="text-secondary">{item.text}</span>
                    </div>
                    <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                      <div
                        className="h-full bg-destructive transition-all duration-1000"
                        style={{ width: `${item.progress}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={`transition-all duration-500 ${activeView === 'ai' ? 'opacity-100 scale-100' : 'opacity-50 scale-95'}`}>
            <div className="bg-card rounded-2xl p-8 border-2 border-primary h-full">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon name="Smile" size={24} color="var(--color-primary)" />
                </div>
                <h3 className="text-2xl font-bold text-foreground">С AI Dating</h3>
              </div>

              <div className="space-y-6">
                {[
                  { icon: 'Zap', text: 'Цифровой двойник проводит тысячи свиданий за вас', progress: 95 },
                  { icon: 'Target', text: 'Вы получаете только готовые результаты', progress: 94 },
                  { icon: 'Heart', text: 'Совместимость по 7 каналам коммуникации', progress: 92 },
                  { icon: 'TrendingUp', text: 'Вы живёте обычной жизнью, пока двойник работает', progress: 100 }
                ].map((item, index) => (
                  <div key={index} className="space-y-2">
                    <div className="flex items-center gap-3">
                      <Icon name={item.icon as any} size={20} color="var(--color-primary)" />
                      <span className="text-foreground font-medium">{item.text}</span>
                    </div>
                    <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                      <div
                        className="h-full bg-primary transition-all duration-1000"
                        style={{ width: `${item.progress}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 text-center max-w-3xl mx-auto">
          <div className="bg-card rounded-3xl p-12 border-2 border-primary shadow-2xl">
            <Icon name="MessageCircle" size={48} color="var(--color-primary)" className="mx-auto mb-6" />
            <h3 className="text-3xl font-bold text-foreground mb-4">
              Готовы попробовать технологию будущего?
            </h3>
            <p className="text-lg text-secondary mb-8">
              Первый шаг — пройти тест на 7 каналов коммуникации. Узнайте, как вы общаетесь через визуал, аудио, кинестетику, логику, эмпатию, вкус и запах.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="default"
                size="lg"
                iconName="Brain"
                iconPosition="right"
                onClick={handleTestClick}
                className="text-base font-semibold"
              >
                Пройти тест органов чувств
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;